module.exports = __webpack_public_path__ + "img/spitter-run-3.fcf9a8c6.png";